import React, { useState, useEffect } from 'react';
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';


const ImageSlider = () => {
  const slides = [
    {
      url: '/bg1.png',
       title: 'vanilla',
    },
    {
      url: '/bg2.jpg',
      title: 'vanilla',
    },
    {
      url: 'bg3.jpg',  
         title: 'vanilla',
    },
    {
      url: 'bg4.jpg',
         title: 'vanilla',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  // Function to automatically change slides every 2 seconds
  const autoChangeSlide = () => {
    nextSlide();
  };

  // Use useEffect to start the automatic slide change
  useEffect(() => {
    const intervalId = setInterval(autoChangeSlide, 3000);

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, [currentIndex]);


  return (
    <div id='home' className='max-w-[full] h-screen w-full    '>
      <div
        className='top-0 left-0 w-full h-full bg-cover   bg-opacity- duration-1000'
        style={{ backgroundImage: `url(${slides[currentIndex].url})` }}
      ></div>
    
      {/* <div className='absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 group-hover:bg-black/20 text-white cursor-pointer'>
        <BsChevronCompactLeft onClick={prevSlide} size={30} />
      </div>
    
      <div className='absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 group-hover:bg-black/20 text-white cursor-pointer'>
        <BsChevronCompactRight onClick={nextSlide} size={30} />
      </div> */}
{/* 
      <div className='flex top-4 justify-center py-2'>
        {slides.map((slide, slideIndex) => (
          <div
            className='text-2xl cursor-pointer'
            key={slideIndex}
            onClick={() => goToSlide(slideIndex)}
          >
            <RxDotFilled />
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default ImageSlider;
